import React from "react";

const CalanderSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32.807"
      height="37.494"
      viewBox="0 0 32.807 37.494"
    >
      <path
        fill="#fff"
        d="M0 33.979a3.516 3.516 0 003.515 3.515h25.777a3.516 3.516 0 003.515-3.515V14.06H0zm23.433-14.353a.881.881 0 01.879-.879h2.929a.881.881 0 01.879.879v2.929a.881.881 0 01-.879.879h-2.929a.881.881 0 01-.879-.879zm0 9.373a.881.881 0 01.879-.879h2.929a.881.881 0 01.879.88v2.929a.881.881 0 01-.879.879h-2.929a.881.881 0 01-.879-.879zm-9.373-9.373a.881.881 0 01.879-.879h2.929a.881.881 0 01.879.879v2.929a.881.881 0 01-.879.879h-2.929a.881.881 0 01-.879-.879zm0 9.373a.881.881 0 01.879-.879h2.929a.881.881 0 01.879.879v2.929a.881.881 0 01-.879.879h-2.929a.881.881 0 01-.879-.879zm-9.373-9.373a.881.881 0 01.879-.879h2.929a.881.881 0 01.879.879v2.929a.881.881 0 01-.879.879h-2.93a.881.881 0 01-.879-.879zm0 9.373a.881.881 0 01.879-.879h2.929a.881.881 0 01.878.88v2.929a.881.881 0 01-.879.879H5.565a.881.881 0 01-.879-.879zM29.292 4.687h-3.515V1.172A1.175 1.175 0 0024.605 0h-2.343a1.175 1.175 0 00-1.172 1.172v3.515h-9.373V1.172A1.175 1.175 0 0010.545 0H8.2a1.175 1.175 0 00-1.17 1.172v3.515H3.515A3.516 3.516 0 000 8.2v3.515h32.807V8.2a3.516 3.516 0 00-3.515-3.513z"
      ></path>
    </svg>
  );
};

export default CalanderSVG;
